<template>
  <div class="page-table lxgc-list">
    <!-- 搜索区 -->
    <div class="page-search">
      <a-form :form="searchForm" @submit="handleSearch">
        <a-row type="flex" align="middle" :gutter="8">
          <a-col :span="5">
            <a-form-item label="报修地点" :labelCol="{span: 6}" :wrapperCol="{span: 18}">
              <a-input v-decorator="['address']" placeholder="请输入关键词搜索" maxlength="50" />
            </a-form-item>
          </a-col>
          <a-col :span="4">
            <a-form-item label="状态" :labelCol="{span: 5}" :wrapperCol="{span: 19}">
              <a-select v-decorator="['status']" placeholder="请选择" allowClear>
                <a-select-option value="">全部</a-select-option>
                <a-select-option value="0">报价中</a-select-option>
                <a-select-option value="1">施工中</a-select-option>
                <a-select-option value="2">已完成</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="5">
            <a-form-item label="操作人" :labelCol="{span: 6}" :wrapperCol="{span: 18}">
              <a-input v-decorator="['operator']" placeholder="请输入关键词搜索" maxlength="50" />
            </a-form-item>
          </a-col>
          <a-col :span="4">
            <a-form-item label="来源" :labelCol="{span: 5}" :wrapperCol="{span: 19}">
              <a-select v-decorator="['source']" placeholder="请选择" allowClear>
                <a-select-option value="">全部</a-select-option>
                <a-select-option value="0">直接创建</a-select-option>
                <a-select-option value="1">报修转派</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6" style="text-align: right;">
            <a-button type="primary" html-type="submit" style="margin-right: 8px;">查询</a-button>
            <a-button type="primary" @click="handleReset">重置</a-button>
          </a-col>
        </a-row>
      </a-form>

      <!-- 操作按钮：主管/负责人 → 批量审批左、导出右；普通用户/管理员 → 新增 + 导出全部靠左 -->
      <div class="action-bar" :class="{ 'action-bar-split': isManagerRole }" style="margin-top: 12px; display: flex; justify-content: space-between; align-items: center;">
        <div class="action-bar-left">
          <template v-if="isManagerRole">
            <a-button type="primary" @click="handleBatchApproval('bj')">批量报价审批</a-button>
            <a-button type="primary" @click="handleBatchApproval('ys')" style="margin-left: 8px;">批量验收审批</a-button>
          </template>
          <template v-else>
            <a-button type="primary" @click="handleAdd">新增</a-button>
            <a-button type="primary" @click="handleExportMaterial" style="margin-left: 8px;">导出材料</a-button>
            <a-button type="primary" @click="handleExportQuote" style="margin-left: 8px;">导出报价单</a-button>
          </template>
        </div>
        <div v-if="isManagerRole" class="action-bar-right">
          <a-button type="primary" @click="handleExportMaterial">导出材料</a-button>
          <a-button type="primary" @click="handleExportQuote" style="margin-left: 8px;">导出报价单</a-button>
        </div>
      </div>

      <!-- 表格 -->
      <div class="table-operator" style="padding: 0; margin-top: 16px;">
        <standard-table
          :columns="columns"
          :dataSource="dataSource"
          :pagination="PAGINATION"
          :bordered="true"
          :showRowSelection="true"
          @rowChange="onRowChange"
          @change="onChange"
        />
      </div>
    </div>

    <!-- 批量审批弹窗 -->
    <a-modal
      :title="batchModal.title"
      :visible="batchModal.visible"
      :confirm-loading="batchModal.submitting"
      :mask-closable="false"
      :width="520"
      :footer="null"
      @cancel="closeBatchModal"
    >
      <div class="batch-modal-body">
        <div class="batch-summary">
          <div class="batch-summary-label">合计金额（元）</div>
          <div class="batch-summary-value">
            <a-spin v-if="batchModal.totalLoading" size="small" />
            <span v-else>￥{{ batchModal.total }}</span>
          </div>
          <div class="batch-summary-meta">已选 {{ batchModal.records.length }} 条记录</div>
        </div>
        <a-form :form="batchForm" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
          <a-form-item label="审核结果">
            <a-radio-group
              v-decorator="['auditStatus', { rules: [{ required: true, message: '请选择审核结果' }] }]"
            >
              <a-radio value="1">通过</a-radio>
              <a-radio value="0">驳回</a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item label="审批意见">
            <a-textarea
              v-decorator="['auditDescription', {
                rules: [
                  { required: true, message: '请输入审批意见' },
                  { max: 200, message: '最多200个字符' }
                ]
              }]"
              :rows="4"
              placeholder="请输入审批意见"
              :maxLength="200"
            />
          </a-form-item>
        </a-form>
        <div class="batch-modal-footer">
          <a-button @click="closeBatchModal">取消</a-button>
          <a-button type="primary" :loading="batchModal.submitting" @click="handleBatchSubmit">确认提交</a-button>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import './lxgc.less'
export default {
  name: 'Lxgc',
  data () {
    const statusMap = { '0': '报价中', '1': '施工中', '2': '已完成' }
    const sourceMap = { '0': '直接创建', '1': '报修转派' }
    const columns = [
      { title: '序号', align: 'center', dataIndex: '_index', width: 60 },
      { title: '报修地点', align: 'center', dataIndex: 'address', width: 200 },
      {
        title: '来源',
        align: 'center',
        dataIndex: 'fromType',
        width: 100,
        customRender: text => sourceMap[text] || text
      },
      { title: '操作人', align: 'center', dataIndex: 'operator', width: 150 },
      {
        title: '状态',
        align: 'center',
        dataIndex: 'status',
        width: 90,
        customRender: text => statusMap[text] || text
      },
      { title: '创建时间', align: 'center', dataIndex: 'createDate', width: 160 },
      {
        title: '操作',
        align: 'center',
        width: 240,
        customRender: (_text, record) => {
          const { status, bjStep, bjLcjd, bjAuditStatus, bgStep, bgLcjd, bgAuditStatus, ysStep, ysLcjd, ysAuditStatus } = record
          // 已完成：供应商提交验收审核通过
          if (status === '2') {
            return (
              <div class="row-operator">
                <a href="javascript:;" onClick={() => this.handleDetail(record)}>详情</a>
              </div>
            )
          }
          // 施工中：LXGC_STATUS=1
          if (status === '1') {
            const nodes = [
              <a href="javascript:;" onClick={() => this.handleDetail(record)}>详情</a>
            ]
            // YS_STEP=1 且 YS_LCJD=1/2/3：进入验收阶段，根据当前用户角色判断是否显示审批按钮
            if (ysStep === '1' && ysAuditStatus !== '-1' && (['1', '2'].includes(ysLcjd) || (ysLcjd === '3' && ysAuditStatus === '0'))) {
              if (this.canAuditForLcjd(ysLcjd)) {
                nodes.push(<a-divider type="vertical" />)
                nodes.push(<a href="javascript:;" onClick={() => this.handleAcceptApproval(record)}>验收审批</a>)
              }
            } else if (bgStep === '1' && bgLcjd === '1' && bgAuditStatus === '0') {
              // BG_STEP=1 且 BG_LCJD=1：变更阶段，只有管理员能审批
              if (this.canAuditForLcjd(bgLcjd)) {
                nodes.push(<a-divider type="vertical" />)
                nodes.push(<a href="javascript:;" onClick={() => this.handleChangeApproval(record)}>变更审批</a>)
              }
            }
            if (!this.isManagerRole) {
              nodes.push(<a-divider type="vertical" />)
              nodes.push(<a href="javascript:;"  onClick={() => this.handleRemove(record)}>删除</a>)
            }
            return <div class="row-operator">{nodes}</div>
          }
          // 报价中：LXGC_STATUS=0
          const nodes = [
            <a href="javascript:;" onClick={() => this.handleDetail(record)}>详情</a>
          ]
          // BJ_STEP=1 且 BJ_LCJD=1/2/3：供应商已提交报价，根据当前用户角色判断是否显示审批按钮
          if (bjStep === '1' && bjAuditStatus !== '-1' && ((['1', '2'].includes(bjLcjd)) || (bjLcjd === '3' && bjAuditStatus === '0'))) {
            if (this.canAuditForLcjd(bjLcjd)) {
              nodes.push(<a-divider type="vertical" />)
              nodes.push(<a href="javascript:;" onClick={() => this.handleQuoteApproval(record)}>报价审批</a>)
            }
          }
          if (!this.isManagerRole) {
            nodes.push(<a-divider type="vertical" />)
            nodes.push(<a href="javascript:;" onClick={() => this.handleRemove(record)}>删除</a>)
          }
          return <div class="row-operator">{nodes}</div>
        }
      }
    ]
    return {
      searchForm: this.$form.createForm(this),
      batchForm: this.$form.createForm(this),
      columns,
      dataSource: [],
      PAGINATION: { total: 0, pageNum: 1, pageSize: 10 },
      selectedRows: [],
      userRoles: [], // 当前用户角色列表
      currentRoleId: '', // 当前切换的角色ID
      currentRoleName: '', // 当前切换的角色名
      batchModal: {
        visible: false,
        submitting: false,
        title: '',
        stage: '',
        step: '',
        records: [],
        total: '0.00',
        totalLoading: false
      }
    }
  },
  computed: {
    // 是否为主管或部门负责人角色（基于当前切换的角色）
    isManagerRole () {
      if (!this.currentRoleId) return false
      const currentRole = this.userRoles.find(r => r.id === this.currentRoleId)
      if (!currentRole) return false
      // 角色 code 为空时，用角色名称兜底匹配
      const code = currentRole.code || ''
      const name = currentRole.name || ''
      if (code.endsWith('BXXT_LXGCZG') || code.endsWith('BXXT_LXGCHQCFZR')) return true
      if (name.indexOf('零星工程主管') !== -1 || name.indexOf('零星工程后勤处负责人') !== -1) return true
      return false
    }
  },
  mounted () {
    this.loadUserRoles()
    this.fetchList(this.getFetchParams())
  },
  methods: {
    /**
     * 加载当前用户角色
     */
    loadUserRoles () {
      this.$axios.post('/api/auth/getRoles.do').then(res => {
        const detail = (res.data && res.data.detail) || {}
        this.userRoles = detail.roles || []
        this.currentRoleId = detail.currentRoleId || ''
        this.currentRoleName = detail.currentRoleName || ''
      }).catch(() => {
        this.userRoles = []
        this.currentRoleId = ''
        this.currentRoleName = ''
      })
    },
    /**
     * 判断当前用户是否有指定流程节点的审批权限
     * 注意：基于当前切换的角色（currentRoleId）而非用户所有角色，避免多角色用户跨阶段重复审批
     * @param lcjd 流程节点 1-管理员 2-主管 3-后勤处负责人
     */
    canAuditForLcjd (lcjd) {
      if (!this.currentRoleId) return false
      const currentRole = this.userRoles.find(r => r.id === this.currentRoleId)
      if (!currentRole) return false
      let requiredRoleCode = ''
      let requiredRoleName = ''
      if (lcjd === '1') {
        requiredRoleCode = 'BXXT_LXGCGLY'
        requiredRoleName = '零星工程管理员'
      } else if (lcjd === '2') {
        requiredRoleCode = 'BXXT_LXGCZG'
        requiredRoleName = '零星工程主管'
      } else if (lcjd === '3') {
        requiredRoleCode = 'BXXT_LXGCHQCFZR'
        requiredRoleName = '零星工程后勤处负责人'
      }
      // 角色 code 为空时，用角色名称兜底匹配
      if (currentRole.code && currentRole.code.endsWith(requiredRoleCode)) return true
      if (currentRole.name && currentRole.name.indexOf(requiredRoleName) !== -1) return true
      return false
    },
    fetchList (params) {
      this.$axios.post('/api/lxgc/list.do', params).then(res => {
        const list = (res.data && res.data.list) || {}
        this.dataSource = list.data || []
        const { currentPageNo, pageSize } = params
        this.PAGINATION = { total: list.totalRecords || 0, pageNum: currentPageNo, pageSize }
      })
    },
    handleSearch (e) {
      e.preventDefault()
      this.fetchList(this.getFetchParams({ pageNum: 1 }))
    },
    handleReset () {
      this.searchForm.resetFields()
      this.fetchList(this.getFetchParams({ pageNum: 1 }))
    },
    onChange (changeParams) {
      this.fetchList(this.getFetchParams(changeParams))
    },
    getFetchParams (customParam) {
      const { pageNum: cpNum, pageSize: cpSize, ...rest } = customParam || {}
      const pageNum = cpNum || this.PAGINATION.pageNum || 1
      const pageSize = cpSize || this.PAGINATION.pageSize || 10
      return {
        ...this.searchForm.getFieldsValue(),
        ...rest,
        pageSize,
        currentPageNo: pageNum,
        sortOrder: 'desc'
      }
    },
    handleAdd () {
      this.$router.push({ path: '/minorWorks/add' })
    },
    handleDetail (record) {
      this.$router.push({ path: '/minorWorks/detail', query: { id: record.id } })
    },
    handleQuoteApproval (record) {
      this.$router.push({ path: '/minorWorks/quoteApproval', query: { id: record.id } })
    },
    handleChangeApproval (record) {
      this.$router.push({ path: '/minorWorks/changeApproval', query: { id: record.id } })
    },
    handleAcceptApproval (record) {
      this.$router.push({ path: '/minorWorks/acceptApproval', query: { id: record.id } })
    },
    handleRemove (record) {
      this.$confirm({
        title: '删除',
        content: '确定删除该数据？',
        onOk: () => {
          this.$axios.post('/api/lxgc/delete.do', { id: record.id }).then(() => {
            this.$message.success('删除成功！')
            this.fetchList(this.getFetchParams())
          })
        }
      })
    },
    /**
     * 批量审批入口
     * @param stage 'bj'(报价审批) | 'ys'(验收审批)
     */
    handleBatchApproval (stage) {
      if (!this.selectedRows.length) {
        this.$message.warning('请先选择记录')
        return
      }
      const filterMap = {
        bj: {
          step: '1',
          stageType: '1',
          title: '批量报价审批',
          predicate: r => r.status === '0' && r.bjStep === '1' && ['1', '2', '3'].includes(r.bjLcjd) && this.canAuditForLcjd(r.bjLcjd)
        },
        ys: {
          step: '3',
          stageType: '3',
          title: '批量验收审批',
          predicate: r => r.status === '1' && r.ysStep === '1' && ['1', '2', '3'].includes(r.ysLcjd) && this.canAuditForLcjd(r.ysLcjd)
        }
      }
      const cfg = filterMap[stage]
      const valid = this.selectedRows.filter(cfg.predicate)
      if (!valid.length) {
        this.$message.warning('所选记录中无可' + cfg.title + '的数据')
        return
      }
      if (valid.length < this.selectedRows.length) {
        this.$message.info(`已自动过滤 ${this.selectedRows.length - valid.length} 条不可审批记录`)
      }
      this.batchModal = {
        visible: true,
        submitting: false,
        title: cfg.title,
        stage,
        step: cfg.step,
        records: valid,
        total: '0.00',
        totalLoading: true
      }
      this.$nextTick(() => {
        this.batchForm.resetFields()
      })
      // 拉取合计金额
      const ids = valid.map(r => r.id).join(',')
      this.$axios.post('/api/lxgc/sumStageTotal.do', { ids, stageType: cfg.stageType }).then(res => {
        const data = (res && res.data) || {}
        this.batchModal.total = data.total || '0.00'
      }).catch(() => {
        this.batchModal.total = '0.00'
      }).finally(() => {
        this.batchModal.totalLoading = false
      })
    },
    closeBatchModal () {
      this.batchModal.visible = false
      this.batchModal.records = []
      this.batchModal.total = '0.00'
      this.batchModal.totalLoading = false
    },
    handleBatchSubmit () {
      this.batchForm.validateFields((err, values) => {
        if (err) return
        this.batchModal.submitting = true
        const { step, records } = this.batchModal
        const ids = records.map(r => r.id).join(',')
        this.$axios.post('/api/lxgc/batchAudit.do', {
          ids,
          step,
          auditStatus: values.auditStatus,
          auditDescription: values.auditDescription || ''
        }).then(res => {
          const data = (res.data && res.data.data) || {}
          const successCount = data.successCount != null ? data.successCount : records.length
          this.$message.success(`批量审批成功，共 ${successCount} 条`)
          this.closeBatchModal()
          this.selectedRows = []
          this.fetchList(this.getFetchParams())
        }).finally(() => {
          this.batchModal.submitting = false
        })
      })
    },
    handleExportMaterial () {
      if (!this.selectedRows.length) {
        this.$message.warning('请先选择记录')
        return
      }
      const ids = this.selectedRows.map(r => r.id).join(',')
      const env = process.env.NODE_ENV
      const url = env === 'production' ? '/export/exportLxgcMaterial.do' : '/api/export/exportLxgcMaterial.do'
      this.exportByForm(url, { ids })
    },
    handleExportQuote () {
      if (!this.selectedRows.length) {
        this.$message.warning('请先选择记录')
        return
      }
      const ids = this.selectedRows.map(r => r.id).join(',')
      const env = process.env.NODE_ENV
      const url = env === 'production' ? '/export/exportLxgcQuote.do' : '/api/export/exportLxgcQuote.do'
      this.exportByForm(url, { ids })
    },
    exportByForm (url, data) {
      const form = document.createElement('form')
      form.action = url
      form.method = 'post'
      for (const key in data) {
        const input = document.createElement('input')
        input.type = 'hidden'
        input.name = key
        input.value = data[key]
        form.appendChild(input)
      }
      document.body.appendChild(form)
      form.submit()
      document.body.removeChild(form)
    },
    onRowChange (rows) {
      this.selectedRows = rows
    }
  }
}
</script>
